const Resources = {

    table_headers: [
        { 
          text:     'Name',
          value:    'name',
          type:     'link',
          event:    true,
        },
        { 
            text:   'Description',
            value:  'description'
        }
    ],
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'QC',
            href:   '/options-master-step-codes',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'QC Inspection Items',
            href:   '/options-master-step-codes',
            arrow:  "",
        },
    ],

    deletion_validation_table_headers: [
        { 
          text:     'Inspection Item',
          value:    'master_step_code',
        },
    ],

    room_type_table_headers: [
        {   
            name:   'Room Type',
        },
    ],

    excel_file_headers: {
        'Name': 'Name',
        'Description': 'Description',
        'Active': 'status',
    },

    empty_format_data: [
        {
            'Name': '',
            'Description': '',
            'status': 'true'
        },
    ],

    helps: [
        {
            label: '¿How to add QC Inspection Items?', 
            instruction: `https://scribehow.com/embed/How_to_Add_QC_Inspection_Items__FoZxkVXsQXKbVNczoPwEJQ?as=scrollable`
        },
    ]
}

export default Resources;